import Navbar from '@/components/feature/Navbar';
import ContactFooter from '@/pages/home/components/ContactFooter';
import CaregiverJobHero from './components/CaregiverJobHero';
import JobTypesSection from './components/JobTypesSection';
import RegistrationForm from './components/RegistrationForm';

export default function CaregiverJobPage() {
  return (
    <div className="min-h-screen w-full">
      <Navbar />
      <main>
        <CaregiverJobHero />
        <JobTypesSection />
        <RegistrationForm />
      </main>
      <ContactFooter />
    </div>
  );
}